// extracted by mini-css-extract-plugin
module.exports = {"flexContainer":"_1SJOPt","content":"_1cz1ce","empty":"_2SujGN"};